import * as r from "react";
import n from "../lib/IconBase.es.js";
import t from "../defs/TrayArrowDown.es.js";
const o = r.forwardRef((a, e) => /* @__PURE__ */ r.createElement(n, { ref: e, ...a, weights: t }));
o.displayName = "TrayArrowDownIcon";
const s = o;
export {
  o as ArchiveTrayIcon,
  s as TrayArrowDown,
  o as TrayArrowDownIcon
};
